export const PriorArtTypes = {
  PATENT: 'Patent',
  UPLOAD_FILE: 'UploadFile',
  MANUAL_ENTRY: 'ManualEntry',
  RECOMMENDATION: 'Recommendation',
  STANDARD: 'Standard',
};

export const PriorArtDocumentType = {
  GRANT: 'GRANT',
  APPLICATION: 'APPLICATION',
  INTERNATIONAL: 'INTERNATIONAL',
  OTHER: 'OTHER',
};

export const countryToLanguageCode = {
  US: 'EN', // English
  CA: 'EN', // English
  WO: 'EN', // English
  GB: 'EN', // English
  EP: 'EN', // English (default for EP), could also be 'FR' or 'DE'
  KR: 'KO', // Korean
  JP: 'JA', // Japanese
  CN: 'ZH', // Chinese
  DE: 'DE', // German
  FR: 'FR', // French
  DEFAULT: 'EN', // Default language if country code is not found
};